<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <cmpconsultartituloscobranca v-bind:idconta="vidconta"></cmpconsultartituloscobranca>            
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstcobrancas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Alterar"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Excluir"><i class="fa fa-trash"></i></button>
                                        <button v-if="parseInt(item.row.apibanco) === 0" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtgerararquivoremessa(item.row.id)" title="Gerar arquivo de remessa"><i class="fa fa-file"></i></button>
                                        <button v-else type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtsolicitarboletos(item.row.id)" title="Enviar solicitação de boletos"><i class="fa fa-bolt"></i></button>
                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud btn-green ajt-btn" @click.prevent="mtddetalhes(item.row.id)" title="Informações da cobrança"><i class="fa fa-info-circle"></i></button>
                                    </template>                                    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.stcobranca) === 0" class="badge badge-pill badge-primary" style="background: #646dd4;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">Remessa gerada</span>
                                    </template>                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_conta" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idconta, 2) }} - {{ item.row.descconta }}</span>
                                    </template>                                    
                                    <template slot="slot_banco" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idbanco, 2) }} - {{ item.row.descbanco }}</span>
                                    </template>                                    
                                    <template slot="slot_totalcobranca" slot-scope="item">
                                        <span style="color: #5a956a; font-weight: 700;">{{ mtdformatavalordecimal(item.row.totalcobranca, 2) }}</span>
                                    </template>                                    
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstcobrancas.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="cbconta">*Conta bancária:</label>
								<select id="cbconta" v-model="vidconta" v-bind:disabled="ativadesativa"
										data-placeholder="Selecione uma opção" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
                                <button type="button" @click.prevent="mtdadicionartitulos()" class="btn btn-primary btn-sm btn-block"
                                        style="margin-top: 20px;" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-plus"></i> Adicionar títulos
                                </button>
							</div> 
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos" @on-select-row="mtdcalculartotais()"
                                        @on-unselect-row="mtdcalculartotais()"
                                        @on-all-select-rows="mtdcalculartotais()"
                                        @on-all-unselect-rows="mtdcalculartotais()"
                                        :rows="lsttituloscob"
                                        :columns="columnstitcob"
                                        :config="configtitcob"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_cliente" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idcliente, 6) }} - {{ item.row.nomecliente }}</span>
                                    </template>
                                    <template slot="slot_valor" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                                                                                             
                                </vue-bootstrap4-table>
                            </div>
                            <div v-show="vqtdselecionados > 0 && parseInt(opcrud) < 3" class="col-sm-12 col-md-12 col-lg-12 text-center" style="margin-bottom: 15px;">
                                <button type="button" @click.prevent="mtdexcluirselecionados()" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i> Excluir selecionados</button>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <ul v-show="parseInt(opcrud) < 3" class="list-group">                                    
                                    <a class="list-group-item lstdettot">Total dos selecionados <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(vtotalselecionado, 2) }}</span></a>
                                </ul>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <ul class="list-group">
                                    <a class="list-group-item lstdettot">Total da cobrança<span class="badge badge-info bdg-totais" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotalcobranca, 2) }}</span></a>
                                </ul>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para visualização dos detalhes da cobrança -->
        <div class="modal fade" id="mddetcob">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Detalhes da cobrança nº: {{ mtdformatarzeros(cobrancadetalhes.id, 7) }}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="eddetcobdesc">Descrição:</label>
                                <input type="text" v-model="cobrancadetalhes.descricao" class="form-control form-control-sm" id="eddetcobdesc" maxlength="50"
                                    style="text-transform: uppercase;" disabled>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddetconta">Conta:</label>
                                <input type="text" class="form-control form-control-sm" id="eddetconta" maxlength="50" v-bind:value="cobrancadetalhes.idconta+' - '+cobrancadetalhes.descconta"
                                    style="text-transform: uppercase;" disabled>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddetcobemissao">Emissão:</label>
                                <input type="text" v-model="cobrancadetalhes.dtemissao" class="form-control form-control-sm" id="eddetcobemissao" maxlength="50"
                                    style="text-transform: uppercase; text-align: right;" disabled>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddetcobtotal">Total da cobrança:</label>
                                <input type="text" v-bind:value="mtdformatavalordecimal(cobrancadetalhes.totalcobranca, 2)" class="form-control form-control-sm" id="eddetcobtotal" maxlength="50"
                                    style="text-align: right;" disabled>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulosdetcob" 
                                        :rows="titulosdetalhescob"
                                        :columns="columnstitdetalhes"
                                        :config="configdetcob"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button v-if="item.row.nossonumero !== ''" type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdimprimirboleto(item.row)" title="Imprimir boleto"><i class="fa fa-barcode"></i></button>
                                    </template>                                                                   
                                    <template slot="slot_nossonumero" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.nossonumero, 8) }}</span>
                                    </template>                                    
                                    <template slot="slot_cliente" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idcliente, 6) }} - {{ item.row.nomecliente }}</span>
                                    </template>
                                    <template slot="slot_valor" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                                                                                             
                                </vue-bootstrap4-table>
                            </div>                            
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4" style="padding-top: 8px;">
                                    <a href="#" role="button" class="btn btn-success btn-sm" @click.prevent="mtdenviaremailcobranca()" data-toggle="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-envelope"></i> Enviar e-mail de cobrança</a>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 8px;">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-close"></i> Cancelar</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>        
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarTitulosCobranca from '../components/cmpconsultartituloscobranca.vue'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadcobrancasbancarias',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'cmpconsultartituloscobranca'      : ConsultarTitulosCobranca
        },
        data: function() {
            return {
                lstcobrancas  : [],
                pfiltro      : 1,
                pconteudo    : '',
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,


                //variáveis do crud
                opcrud              :  0,
                lsttituloscob       : [],
                vid                 : '',
                vdescricao          : '',
                vidconta            : null,
                vtotalcobranca      : 0,


                vtotalselecionado   : 0,
                vqtdselecionados    : 0,
                //variável para habilitação dos campos
                ativadesativa       : true,

                //variáveis para visualização dos detalhes da cobrança
                cobrancadetalhes    : [],
                titulosdetalhescob  : [],

                options: {
                    format          : 'DD/MM/YYYY',
                    useCurrent      : false,
                    locale          : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'COBRANÇAS BANCÁRIAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-cob",
                        sort: false
                    },
                    {
                        label: "Situação",
                        name: "stcobranca",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Conta",
                        name: "descconta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_conta",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Banco",
                        name: "descbanco",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_banco",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total cobrança",
                        name: "totalcobranca",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_totalcobranca",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }                    
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                columnstitcob: [
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor",
                        name: "vlresta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valor",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Observações",
                        name: "obstit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],                
                columnstitdetalhes: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-det",
                        sort: false
                    },                    
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Nosso número",
                        name: "nossonumero",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nossonumero",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor",
                        name: "vlresta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valor",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "E-mail",
                        name: "email",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Observações",
                        name: "obstit",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],                
                configtitcob: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                
                configdetcob: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
			mtdformatavalordecimal(valor, digitos){
				try {
					return util.formatavalordecimais(valor, digitos);
				}
				catch (e) {
					return 0;
				}                
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},             
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and c.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(c.descricao) like upper("'+this.pconteudo+'%")';
                }
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and c.dtemissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
				}                                              
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregacobrancas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregacobrancas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                retorno.then(function (response) {
                    vself.lstcobrancas = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstcobrancas = [];
                    loader.hide();
                });
            },
			mtdselect2_def(){
				let vself  = this;
				$("#cbconta").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcontasbancarias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidconta      = $("#cbconta").val();
                    vself.lsttituloscob  = [];
				});
			},            
            resetarDados() {
                util.toTop();

                this.lsttituloscob      = [];
                this.vid                = '';
                this.vdescricao         = '';
                this.vidconta           = null;
                this.vtotalcobranca     = 0;

                this.vtotalselecionado  = 0;
                this.vqtdselecionados   = 0;
                this.configtitcob.checkbox_rows = true;
                this.$refs.reflsttitulos.selected_items = [];

                $('#cbconta').val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('030Z.020Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE COBRANÇA BACÁRIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstcobrancas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and c.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(response.data[0].stcobranca) === 1 ){
                        vself.$toastr.i('Cobrança já gerou arquivo de remessa, impossível realizar esta operação!', 'Informação!');
                        vself.mtdcancelaredicao();
                        return;
                    }
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('030Z.020Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE COBRANÇAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('030Z.020Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                        
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE COBRANÇAS BANCÁRIAS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                    this.configtitcob.checkbox_rows = false;
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;                
                this.vtotalcobranca      = registro.totalcobranca;
                this.lsttituloscob       = registro.titulos;

                var defconta  = new Option(registro.descconta, registro.idconta, true, true);
                $('#cbconta').append(defconta).trigger('change');

                this.vqtdselecionados   = this.$refs.reflsttitulos.selected_items.length;
            
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idconta'           : this.vidconta,
                    'totalcobranca'     : this.vtotalcobranca,
                    'titulos'           : this.lsttituloscob
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '030Z.020Z.010Z' : parseInt(this.opcrud) === 2 ? '030Z.020Z.020Z' : '030Z.020Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo= 0;
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregacobrancas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdadicionartitulos(){
                if (this.vidconta === null){
                    this.$toastr.w('Conta deve ser informa!', 'Informação!');
                    $('#cbconta').select2('open');
                    return;
                }
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('CONSULTA_TITCOB_CHANGE',payload);

                let payloadtit = {
                    lsttituloscobret    : []
                };
                this.$store.commit('TITCOB_RETORNO_CHANGE',payloadtit);                
            },
            mtdcalculartotais(){
                this.vtotalcobranca = 0;
                for (let titulo of this.lsttituloscob) {
                    this.vtotalcobranca = this.vtotalcobranca + titulo.vlresta;
                }
                this.vtotalselecionado = 0;
                for (let titulo of this.$refs.reflsttitulos.selected_items) {
                    this.vtotalselecionado = this.vtotalselecionado + titulo.vlresta;
                }
                this.vqtdselecionados   = this.$refs.reflsttitulos.selected_items.length;
            },
            mtdexcluirselecionados(){
                let lsttitulostmp = [];
                for (let titulo of this.lsttituloscob) {
                    if (!this.mtdestaselecionado(titulo.idcliente, titulo.codtit)){
                        lsttitulostmp.push(titulo);
                    }
                }
                this.lsttituloscob = [];
                this.lsttituloscob = lsttitulostmp;
                this.$refs.reflsttitulos.selected_items = [];
                this.mtdcalculartotais();
            },
            mtdestaselecionado(idcliente, codtit){                
                for (let titulo of this.$refs.reflsttitulos.selected_items){
                    if (titulo.codtit === codtit && parseInt(titulo.idcliente) === parseInt(idcliente)){
                        return true;
                    }
                }
                return false;
            },
            mtexistenalista(idcliente, codtit){                
                for (let titulo of this.lsttituloscob){
                    if (titulo.codtit === codtit && parseInt(titulo.idcliente) === parseInt(idcliente)){
                        return true;
                    }
                }
                return false;
            },
            mtgerararquivoremessa(idcobranca){
                let vself  = this;
                if (!util.opcaousuario('030Z.020Z.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {   
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma geração do arquivo de remessa?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'gerarremessa'},
                                        {parametro: 'id',           valor : idcobranca},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.020Z.050Z'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if (parseInt(response.data.ret) === 0){
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            let vconteudoarquivo = response.data.conteudoarquivorem;
                                            let nomearquivo      = response.data.nomearquivo;
                                            vself.pfiltroperiodo= 0;
                                            vself.pfiltro       = 0;
                                            vself.pconteudo     = idcobranca;
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcarregacobrancas(1);
                                            //util.download(vconteudoarquivo, vself.mtdformatarzeros(idcobranca, 7)+'.REM');
                                            util.download(vconteudoarquivo, nomearquivo);
                                        }else{
                                            vself.$toastr.e(response.data.ret, 'Erro!');
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    }); 
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#btgravar').focus();
                                }
                            }
                        }
                    });                       
                }               
            },
            mtsolicitarboletos(idcobranca){
                let vself  = this;
                if (!util.opcaousuario('030Z.020Z.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {   
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma solicitação de boletos?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'solicitarboletoapi'},
                                        {parametro: 'id',           valor : idcobranca},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.020Z.050Z'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if (parseInt(response.data.ret) === 0){
                                            vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
                                            vself.pfiltroperiodo= 0;
                                            vself.pfiltro       = 0;
                                            vself.pconteudo     = idcobranca;
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcarregacobrancas(1);
                                        }else{
                                            vself.$toastr.e(response.data.ret, 'Erro!');
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    }); 
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#btgravar').focus();
                                }
                            }
                        }
                    });                       
                }               
            },
            mtddetalhes(idcobranca){
                var vself       = this;
                if (!util.opcaousuario('030Z.020Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{                          
                    let loader      = vself.$loading.show();
                    let filtro      = ' and c.id='+idcobranca;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (parseInt(response.data[0].stcobranca) === 0){
                            vself.$toastr.w('Arquivo de remessão ainda não foi gerado!', 'Atenção!');
                        }else{
                            vself.$refs.reflsttitulosdetcob.selected_items = [];
                            vself.cobrancadetalhes      = response.data[0];
                            vself.titulosdetalhescob    = vself.cobrancadetalhes.titulos;
                            $('#mddetcob').modal('show');
                        }
                    }).catch(function (response) {
                        loader.hide();
                    });                        
                }
            },
            mtdenviaremailcobranca(){
                let vself = this;
                if (vself.$refs.reflsttitulosdetcob.selected_items.length === 0){
                    vself.$toastr.i('Selecione ao menos um título para enviar o email!', 'Informação!');
                }else{
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'enviaremailcobranca'},
                        {parametro: 'titulos',      valor : JSON.stringify(vself.$refs.reflsttitulosdetcob.selected_items)}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcobrancasbancarias.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (parseInt(response.data) === 0){
                            $('#mddetcob').modal('hide');
                            vself.$toastr.s('E-mails enviados com sucesso!', 'Informação!');
                        }else{
                            let tpret = response.data.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                    break;
                            }                            
                        }
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });
                }
            },
            mtdimprimirboleto(titulo){
                let titulos = []
                let titulostmp = {
                    codtit   : titulo.codtit,
                    idcliente: titulo.idcliente
                }  
                titulos.push(titulostmp)
                let dados = {
                    josntitulos: titulos
                }; 
                //passar url
                window.open(this.$store.state.configpaths.pathcontrole+'rtcadcobrancasbancarias.php?op=gerarboleto'+
                    '&dados=' + encodeURIComponent(JSON.stringify(dados))+
                    '&idclientesac='+this.$store.state.filialpadrao.idcliente,
                    '_blank');
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('030Z.020Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidconta === null || this.lsttituloscob.length === 0;
            },
            selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            lsttitulosretorno(){
                return this.$store.state.tituloscobretornoconsulta.lsttituloscobret;
			}
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregacobrancas(val);
            },
            lsttitulosretorno(val){
                if (val.length > 0){
                    for (let titulo of val){
                        if (!this.mtexistenalista(titulo.idcliente, titulo.codtit)){
                            this.lsttituloscob.push(titulo);
                        }
                    }                  
                    this.mtdcalculartotais();
                }
			}        
        }
    }
</script>
<style>
    .def-col-opcoes-cob{
        width: 180px !important;
    }
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-situacao{
        width: 100px !important;
    }
    .def-col-opcoes-dt{
        width: 40px !important;
    }    
</style>